import React, { memo } from 'react';
import { resolveBlockClaimSupport } from '../../utils/claimSupport';
import styles from './structured/structuredResponse.module.css';

function ClaimSupportFooter({ block, renderContext }) {
    const support = resolveBlockClaimSupport(
        block,
        renderContext?.citations,
        renderContext?.chunks,
    );
    if (!support?.sourceCount) return null;

    const labels = [
        `${support.sourceCount} source${support.sourceCount === 1 ? '' : 's'}`,
        ...support.workstreams,
        ...support.sourceTypes,
    ].filter(Boolean);

    const handleClick = () => {
        renderContext?.onViewEvidence?.();
    };

    return (
        <div className={styles.claimSupportFooter}>
            <span className={styles.claimSupportLabel}>Supported by:</span>
            {renderContext?.onViewEvidence ? (
                <button type="button" className={styles.claimSupportButton} onClick={handleClick}>
                    {labels.join(' · ')}
                </button>
            ) : (
                <span className={styles.claimSupportText}>{labels.join(' · ')}</span>
            )}
        </div>
    );
}

export default memo(ClaimSupportFooter);
